export { default } from './LangSetting'
